import {
    Currency,
    TradingProcedure,
    TradingProcedureType,
} from '../../../domain/trading-procedure/models/trading-procedure.model';
import {
    CurrencyEnumDto,
    TradingProcedureResponseDto,
    TradingProcedureStatusDto,
    TradingProcedureTypeDto,
} from '@tradgine/data-access/tradgine-data';

export function toTradingProcedure(dto: TradingProcedureResponseDto): TradingProcedure {
    return {
        id: dto.id,
        showSellerName: dto.showSellerName,
        name: dto.name,
        sellerOrganizationName: dto.sellerOrganizationName,
        sellerOrganizationLogo: dto.sellerOrganizationLogo,
        sellerOrganizationTypeName: dto.sellerOrganizationTypeName,
        sellerOrganizationId: dto.sellerOrganizationId,
        startDateTime: new Date(dto.startDateTime),
        endDateTime: new Date(dto.endDateTime),
        auctionExtensionSeconds: dto.auctionExtensionSeconds,
        status: toStatus(dto.status),
        type: toTradingProcedureType(dto.type),
        bidStepAmount: dto.bidStepAmount,
        sellerDescription: dto.sellerDescription,
        platformNote: dto.platformNote,
        landingDescription: dto.landingDescription,
        showOnLanding: dto.showOnLanding,
        currency: toCurrency(dto.currency),
        createdDateTime: new Date(dto.createdDateTime),

        lotCount: dto.lotCount,
        contractCount: dto.contractCount,
        debtAmount: dto.debtAmount,
        principalAmount: dto.principalAmount,
        averageDpd: dto.averageDpd,
        minPrice: dto.minPrice,
        currentPrice: dto.currentPrice,
    };
}

export function toStatus(status: TradingProcedureStatusDto): TradingProcedure['status'] {
    switch (status) {
        case TradingProcedureStatusDto.Draft: return 'draft';
        case TradingProcedureStatusDto.Active: return 'active';
        case TradingProcedureStatusDto.Published: return 'published';
        case TradingProcedureStatusDto.AwaitingDecision: return 'awaitingDecision';
        case TradingProcedureStatusDto.Finished: return 'finished';
        case TradingProcedureStatusDto.Cancelled: return 'canceled';
    }
}

export function toCurrency(currency: CurrencyEnumDto): Currency {
    switch (currency) {
        case CurrencyEnumDto.Euro: return 'Euro';
    }
}

export function toTradingProcedureType(type: TradingProcedureTypeDto): TradingProcedureType {
    switch (type) {
        case TradingProcedureTypeDto.English: return 'English';
        case TradingProcedureTypeDto.Sealed: return 'Sealed';
    }
}
